(function(){
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents){
    var fmt = (window.amzMoneyFormat || '{{amount}} EGP');
    var v = (cents/100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, withCommas)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
              .replace(/\{\{\s*amount[^}]*\}\}/, withCommas + '.' + parts[1]);
  }
  window.amzMoney = money;

  function initHero(el){
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var track = el.querySelector('.amz-hero__track');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var i = 0, timer = null, rtl = document.documentElement.dir === 'rtl';
    function go(n){
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (rtl ? i*100 : -i*100) + '%)';
      Array.prototype.forEach.call(slides, function(s, k){ s.setAttribute('aria-hidden', k !== i); s.tabIndex = k === i ? 0 : -1; });
    }
    function play(){ if (reduce) return; stop(); timer = setInterval(function(){ go(i+1); }, (parseInt(el.dataset.speed,10)||6)*1000); }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    var p = el.querySelector('.amz-hero__arrow--prev'), n = el.querySelector('.amz-hero__arrow--next');
    p && p.addEventListener('click', function(){ go(i-1); play(); });
    n && n.addEventListener('click', function(){ go(i+1); play(); });
    el.addEventListener('mouseenter', stop); el.addEventListener('mouseleave', play);
    el.addEventListener('focusin', stop); el.addEventListener('focusout', play);
    go(0); play();
  }

  function initRow(el){
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var track = el.querySelector('.amz-row__track');
    if (!track) return;
    var rtl = document.documentElement.dir === 'rtl';
    el.querySelectorAll('.amz-row__btn').forEach(function(b){
      b.addEventListener('click', function(){
        var dir = b.classList.contains('amz-row__btn--next') ? 1 : -1;
        if (rtl) dir = -dir;
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  var toastTimer;
  function toast(item){
    var t = document.getElementById('amz-toast');
    if (!t) return;
    var img = t.querySelector('img');
    if (img) { if (item && item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; } }
    var name = t.querySelector('[data-amz-toast-name]');
    if (name) name.textContent = item ? item.product_title : '';
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('is-open'); }, 5000);
  }

  function refreshCount(){
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-amz-cart-count]').forEach(function(c){ c.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('amz:cart-updated', { detail: cart }));
        return cart;
      });
  }

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-amz-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-amz-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
        toast(res.j.items ? res.j.items[0] : res.j);
        return refreshCount();
      })
      .catch(function(ex){
        if (err) { err.textContent = ex.message; err.hidden = false; } else { alert(ex.message); }
      })
      .finally(function(){ if (btn) btn.removeAttribute('aria-busy'); });
  });

  function initSearch(holder){
    if (holder.dataset.ready) return; holder.dataset.ready = '1';
    var input = holder.querySelector('input[name=q]');
    var box = holder.querySelector('.amz-predict');
    if (!input || !box) return;
    var timer, ctrl;
    function close(){ box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    input.addEventListener('input', function(){
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function(){
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { signal: ctrl.signal })
          .then(function(r){ return r.json(); })
          .then(function(d){
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            box.innerHTML = '';
            if (!items.length) { close(); return; }
            items.forEach(function(p){
              var a = document.createElement('a');
              a.href = p.url; a.setAttribute('role', 'option');
              if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
              var s = document.createElement('span'); s.textContent = p.title; a.appendChild(s);
              box.appendChild(a);
            });
            box.hidden = false; input.setAttribute('aria-expanded', 'true');
          }).catch(function(){});
      }, 220);
    });
    input.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    document.addEventListener('click', function(e){ if (!holder.contains(e.target)) close(); });
  }

  function initFilters(form){
    if (form.dataset.ready) return; form.dataset.ready = '1';
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t.form === form && t.matches('input[type=checkbox], select')) form.submit();
    });
    var tg = document.querySelector('[data-amz-filters-toggle]');
    var panel = document.querySelector('.amz-filters__panel');
    if (tg && panel) tg.addEventListener('click', function(){
      var open = panel.classList.toggle('is-open');
      tg.setAttribute('aria-expanded', open);
    });
  }

  function initPdp(el){
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var dataEl = el.querySelector('[data-amz-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var mainImg = el.querySelector('.amz-gallery__main img');
    var thumbs = el.querySelectorAll('.amz-gallery__thumbs button');
    function showMedia(src, srcset, id){
      if (!mainImg) return;
      mainImg.src = src; if (srcset) mainImg.srcset = srcset;
      thumbs.forEach(function(t){ t.setAttribute('aria-current', t.dataset.mediaId == id ? 'true' : 'false'); });
    }
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ showMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId); });
      t.addEventListener('mouseenter', function(){ showMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId); });
    });
    var about = el.querySelector('.amz-about__body');
    var more = el.querySelector('.amz-about__more');
    if (about && more) {
      if (about.scrollHeight <= about.clientHeight + 10) { about.classList.remove('is-clamped'); more.hidden = true; }
      more.addEventListener('click', function(){
        var c = about.classList.toggle('is-clamped');
        more.textContent = c ? more.dataset.more : more.dataset.less;
        more.setAttribute('aria-expanded', !c);
      });
    }
    var fieldsets = el.querySelectorAll('.amz-opt');
    if (!fieldsets.length) return;
    function current(){
      return Array.prototype.map.call(fieldsets, function(f){ var c = f.querySelector('input:checked'); return c ? c.value : null; });
    }
    function update(){
      var sel = current();
      fieldsets.forEach(function(f, idx){ var lab = f.querySelector('[data-amz-opt-value]'); if (lab) lab.textContent = sel[idx] || ''; });
      var v = product.variants.find(function(x){ return x.options.every(function(o, k){ return o === sel[k]; }); });
      var ids = el.querySelectorAll('input[name=id]');
      var btns = el.querySelectorAll('[data-amz-add-btn]');
      var stock = el.querySelectorAll('[data-amz-stock]');
      if (!v) {
        btns.forEach(function(b){ b.disabled = true; b.textContent = b.dataset.unavailable; });
        return;
      }
      ids.forEach(function(i){ i.value = v.id; });
      btns.forEach(function(b){ b.disabled = !v.available; b.textContent = v.available ? b.dataset.add : b.dataset.soldout; });
      stock.forEach(function(s){ s.textContent = v.available ? s.dataset.in : s.dataset.out; s.classList.toggle('is-out', !v.available); });
      el.querySelectorAll('[data-amz-price-now]').forEach(function(p){ p.textContent = money(v.price); });
      el.querySelectorAll('[data-amz-price-was]').forEach(function(p){
        var on = v.compare_at_price && v.compare_at_price > v.price;
        p.hidden = !on; if (on) p.textContent = money(v.compare_at_price);
        if (p.parentElement && p.parentElement.classList.contains('amz-info__taxes')) p.parentElement.hidden = !on;
      });
      el.querySelectorAll('[data-amz-price-off]').forEach(function(p){
        var on = v.compare_at_price && v.compare_at_price > v.price;
        p.hidden = !on; if (on) p.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      });
      el.querySelectorAll('[data-amz-sku]').forEach(function(s){ s.textContent = v.sku || '—'; });
      if (v.featured_media && v.featured_media.preview_image) {
        var t = el.querySelector('.amz-gallery__thumbs button[data-media-id="' + v.featured_media.id + '"]');
        if (t) showMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId);
      }
      if (el.dataset.updateUrl === 'true') {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    fieldsets.forEach(function(f){ f.addEventListener('change', update); });
  }

  function initAll(scope){
    (scope || document).querySelectorAll('[data-amz-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-amz-row]').forEach(initRow);
    (scope || document).querySelectorAll('[data-amz-search]').forEach(initSearch);
    (scope || document).querySelectorAll('form[data-amz-filters]').forEach(initFilters);
    (scope || document).querySelectorAll('[data-amz-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('click', function(e){ if (e.target.closest('[data-amz-toast-close]')) { var t = document.getElementById('amz-toast'); t && t.classList.remove('is-open'); } });
})();
